export class CameraModule {
    static get Videos(): string { return 'app.cameras.videos'; }
    static get Events(): string { return 'app.cameras.events'; }
    static get EventView(): string { return 'app.cameras.events.view'; }
    static get History(): string { return 'app.cameras.history';}
    static get Vehicles(): string { return 'app.cameras.vehicles'; }
    static get VehicleView(): string { return `${CameraModule.Vehicles}.view`; }
    static get Drivers(): string { return 'app.cameras.drivers'; }
    static get Coaching(): string { return 'app.cameras.coaching'; }
    static get Downloads(): string { return 'app.cameras.downloads'; }

    static get Default(): string { return this.Vehicles; }
    static get ParentRoot(): string { return "app.cameras"; }
}
